import { HOMEPAGE_GPT_ID } from '@/lib/ads/ads-config/homepage/homepageAdSlots'

import { StyledGptLeaderBase } from './styled'

export const GptLeaderBase = () => {
  return (
    <StyledGptLeaderBase
      id={HOMEPAGE_GPT_ID.LEADER_BASE}
      data-testid={HOMEPAGE_GPT_ID.LEADER_BASE}
    />
  )
}
